//DUCKS pattern
import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DetailedSolution, DetailedSolutionsRequest } from 'app/model/SOL49';
import { ServiceFactory } from 'app/service/ServiceFactory';
import Utils from 'app/common/util/Utils';

//type of the state managed by the reducer
interface SolutionState {
    detailedSolutions: DetailedSolution[];
    getDetailedSolutionStatus: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: SolutionState = {
    //empty
    getDetailedSolutionStatus: 'idle',
    detailedSolutions: [],
};

const solutionSlice = createSlice({
    name: 'solution', // string that will be used as the prefix for generated action types
    initialState,
    reducers: {
        setDetailedSolutions(state: SolutionState, action: PayloadAction<Array<DetailedSolution>>) {
            state.detailedSolutions = action.payload;
        },
        cleanDetailedSolutions(state: SolutionState) {
            state.detailedSolutions = [];
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getDetailedSolutions.pending, (state, action) => {
                state.getDetailedSolutionStatus = 'loading';
            })
            .addCase(getDetailedSolutions.fulfilled, (state, action) => {
                state.getDetailedSolutionStatus = 'succeeded';
                if (action.payload.error) {
                    state.getDetailedSolutionStatus = 'failed';
                } else {
                    state.detailedSolutions = action.payload.data.solutions;
                }
            })
            .addCase(getDetailedSolutions.rejected, (state, action) => {
                state.getDetailedSolutionStatus = 'failed';
            });
    },
});

export const getDetailedSolutions = createAsyncThunk(
    'posts/getDetailedSolutions',
    async (request: DetailedSolutionsRequest) => {
        return await ServiceFactory.sol49Service().getDetailedSolutions(request);
    },
);

export const { setDetailedSolutions, cleanDetailedSolutions } = solutionSlice.actions;

export const selectSolutionTvByName = createSelector(
    [
        // Usual first input - extract value from `state`
        (state: SolutionState) => state.detailedSolutions,
        // Take the second arg, `names`, and forward to the output selector
        (state: SolutionState, names: Array<string>) => names,
    ],
    // Output selector gets (`items, names)` as args
    (items: Array<DetailedSolution>, names: Array<string>) => items?.filter(item => Utils.contains(names, item.name)),
);

export default solutionSlice.reducer;
